import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Henkyakuhoho = props => {
  return <Dropdown.Static kubunKey='henkyakuhoho' {...props} />
}
